import { useState } from 'react';
import toast from 'react-hot-toast';
import { listSilobagsService } from '@siloreal:shared:api/service/silobag/silobag-list';
import { getHeaderReportDefinition, type HeaderReportKind } from '../extra/header-report-config';
import { downloadSilobagReport } from '../extra/silobag-report-export';
import * as HOOKS from '@siloreal:shared:hooks';

const REPORT_PAGE_SIZE = 9_999_999_999;

function getReportFileName(label: string): string {
  const today = new Date();
  const date = [
    String(today.getDate()).padStart(2, '0'),
    String(today.getMonth() + 1).padStart(2, '0'),
    today.getFullYear(),
  ].join('-');

  return `Reporte de ${label} - ${date}`;
}

export function useHeaderReportActions() {
  const [isExporting, setIsExporting] = useState(false);

  const i18n = HOOKS.useLocale.getState();

  const downloadReport = async (kind: HeaderReportKind): Promise<void> => {
    if (isExporting) return;

    const definition = getHeaderReportDefinition(kind);
    const loadingToastId = toast.loading(
      `${i18n.t('temp.common.toasts.loading.generating_report')} ${definition.label}...`
    );
    setIsExporting(true);

    try {
      const response = await listSilobagsService({
        pagination: { page: 0, take: REPORT_PAGE_SIZE },
        filter: definition.filters,
      });
      const exportedCount = await downloadSilobagReport(response.data, getReportFileName(definition.label));

      toast.success(
        `${i18n.t('temp.private.list.silospro.silopro_closure_modal.performed')} ${exportedCount} ${i18n.t('temp.common.toasts.success.exported_part_2')}`,
        {
          id: loadingToastId,
        }
      );
    } catch {
      toast.error(`${i18n.t('temp.common.toasts.error.generating_report')} ${definition.label}.`, {
        id: loadingToastId,
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    isExporting,
    downloadCombined: () => void downloadReport('combined'),
    downloadSilosPro: () => void downloadReport('silospro'),
    downloadSilobags: () => void downloadReport('silobag'),
  };
}
